import { searchClient, type SearchClient } from '@algolia/client-search';

declare global {
  interface Window {
    ALGOLIA_APP_ID: string;
    ALGOLIA_SEARCH_ONLY_API_KEY: string;
    ALGOLIA_SEARCH_INDEX_NAME: string;
    hub_search_props?: {
      title: string;
      dataset: string[];
      suggestedSearches: string[];
    };
  }
}

const hasAlgolia = window.ALGOLIA_APP_ID && window.ALGOLIA_SEARCH_ONLY_API_KEY;

export const indexName = hasAlgolia ? window.ALGOLIA_SEARCH_INDEX_NAME : '';

export const algoliaClient = hasAlgolia
  ? searchClient(window.ALGOLIA_APP_ID, window.ALGOLIA_SEARCH_ONLY_API_KEY)
  : null;

export const instanceSearchClass = window.hub_search_props?.dataset || [
  'CaseNotePage',
];

export const instanceSearchClient: SearchClient | null = {
  ...algoliaClient,
  search(requests) {
    // @ts-expect-error failing type check
    requests = requests.map((request) => {
      // query suggestions should not be filtered
      if (request.indexName.includes('query_suggestion')) {
        return request;
      }

      // filter the request to only include case notes
      // add  [['objectClassName:BOS\\Pages\\CaseNotePage']] to the facetFilters
      const facetFilters = request.params.facetFilters || [];

      // if any of the facetFilters are for CaseDate then move them to the numericFilters
      const numericFilters = [];

      // if date is in the url then we need to add it to the numericFilters
      const url = new URL(window.location.href);
      const dateFilter = url.searchParams.get('date');

      if (dateFilter) {
        const colon = dateFilter.includes(' TO ') ? ':' : '';
        numericFilters.push(`CaseDate${colon} ${dateFilter}`);
      }

      const classesToSearch = instanceSearchClass.map((className) => {
        return `objectClassName:BOS\\Pages\\${className}`;
      });

      return {
        ...request,
        params: {
          ...request.params,
          facetFilters: [...facetFilters, classesToSearch],
          numericFilters,
        },
      };
    });

    return algoliaClient.search(requests);
  },
};
